import { render, staticRenderFns } from "./jddz.vue?vue&type=template&id=ac90f374&scoped=true&"
import script from "./jddz.vue?vue&type=script&lang=js&"
export * from "./jddz.vue?vue&type=script&lang=js&"
import style0 from "./jddz.vue?vue&type=style&index=0&id=ac90f374&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac90f374",
  null
  
)

export default component.exports